import { AlertProps, Icon, IconType } from "flux";

export const getAlertDialogConfig = (type: AlertProps["severity"]): AlertProps => {
  switch (type) {
    case "warning": {
      return {
        variant: "standard",
        severity: "warning",
        icon: <Icon name={IconType.TriangleExclamation} color="warning" />
      };
    }
    case "success": {
      return {
        variant: "standard",
        severity: "success",
        icon: <Icon name={IconType.ArrowDown} color="success" />
      };
    }
    case "error": {
      return {
        variant: "standard",
        severity: "error",
        icon: <Icon name={IconType.TriangleExclamation} color="error" />
      };
    }
    case "info": {
      return {
        variant: "standard",
        severity: "info",
        icon: <Icon name={IconType.ArrowDown} color="info" />
      };
    }
    default: {
      return {
        variant: "standard",
        severity: "info"
      };
    }
  }
};
